var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#324561",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 48,
    y1: 12,
    x2: 76,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#324561",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 48,
    y1: 22,
    x2: 76,
    y2: 22
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA66C"
    },
    d: "M24.033,43.994c-6.674,0.001-13.204-3.331-16.994-9.396C3.357,28.706,2.98,21.463,6.031,15.223 c0.728-1.489,2.526-2.104,4.013-1.378c1.488,0.728,2.105,2.524,1.378,4.013c-2.136,4.368-1.871,9.438,0.705,13.562 c4.092,6.546,12.744,8.544,19.292,4.454c6.546-4.092,8.544-12.746,4.454-19.292c-2.574-4.12-7.01-6.579-11.867-6.579 c-0.005,0-0.011-0.002-0.015,0c-1.656,0-2.999-1.342-3-2.997c-0.001-1.657,1.341-3.002,2.997-3.003c0.006,0,0.013,0,0.019,0 c3.829,0,7.475,1.069,10.591,3.017c2.532,1.582,3.953,3.942,5.602,6.581c5.844,9.352,3.75,20.855-5.601,26.7 C31.312,42.354,27.65,43.994,24.033,43.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA66C"
    },
    d: "M14.759,9.164c-0.085-0.611-0.446-1.149-0.981-1.459c-0.534-0.309-1.184-0.353-1.754-0.12 l-8.211,3.343c-0.708,0.288-1.189,0.954-1.241,1.716c-0.053,0.762,0.334,1.487,0.995,1.869l9.422,5.439 c0.311,0.179,0.655,0.268,1,0.268c0.391,0,0.779-0.114,1.116-0.341c0.634-0.426,0.97-1.176,0.865-1.933L14,13L14.759,9.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324561"
    },
    d: "M24,44c-0.553,0-1-0.447-1-1s0.447-1,1-1c9.925,0,18-8.075,18-18c0-6.252-3.166-11.96-8.47-15.269 c-0.469-0.293-0.611-0.909-0.319-1.378s0.908-0.611,1.378-0.319C40.481,10.711,44,17.053,44,24C44,35.028,35.028,44,24,44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324561"
    },
    d: "M14.979,19.083c-0.492,0-0.921-0.362-0.989-0.863l-1.211-8.781c-0.076-0.547,0.307-1.052,0.854-1.127 c0.559-0.086,1.052,0.307,1.127,0.854l1.211,8.781c0.076,0.547-0.307,1.052-0.854,1.127C15.069,19.08,15.023,19.083,14.979,19.083z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4ede90b34adde8c536c2a8dd2dfdcc73.svg";
export { ForwardRef as ReactComponent };